import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const Title = styled(Typography)({
	fontWeight: '600',
	fontSize: '20px',
	textAlign: 'center',
	color: '#333333',
});

export const Subtitle = styled(Typography)(({ theme }) => ({
	fontWeight: 300,
	lineHeight: '150%',
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));
